import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-asset-dashboard-details',
  templateUrl: './asset-dashboard-details.component.html',
  styleUrls: ['./asset-dashboard-details.component.scss'],
})
export class AssetDashboardDetailsComponent implements OnInit {
  loggedInUserId: any;
  moduleName: any;
  allDataForDispay: any = [];
  newAssetListingData: any = [];
  repairedAsset: any = [];
  returnAsset: any = [];
  EmployeereturnAsset: any = [];
  notRecivedAsset: any = []
  isToggleOn: boolean = true;
  type: any = "Recived Asset";
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService, private config: Config, private encryptionService: EncryptionService,) {
    console.log(data);
    this.moduleName = data.moduleName;
    this.allDataForDispay = data.allApiData;
    this.repairedAsset = data.repairedsset;
    this.loggedInUserId = data.loggdingUserId;
    this.newAssetListingData = data.newAllAssetListingData


  }


  ngOnInit() {
    this.returnData()
  }
  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = formatYearRanges(data?.data?.yearRanges);

  //     const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

  //     const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  //     this.setSelectedYear(yearValue);

  //   });
  // }
  // setSelectedYear(yearValue: string): void {
  //   const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
  //   if (selectedYearObj) {
  //     this.selectedYearForCompetency = selectedYearObj?.year;
  //         // this.selectedYearForGraphOneHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphTwoHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphFifthHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphSix = selectedYearObj?.year;
  //         // this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year;

  //     let test = selectedYearObj?.year.split('-');
  //     this.fromYear = test[0];
  //     this.toYear = test[1];
  //   }
  // }

  exportDashboardListExcel() {


    // Define the fields to be downloaded
    const exportFields1 = [
      'employeeName',
      'band',
      'assetName',

    ];
    const exportFields2 = [
      'employeeName',
      'unassignedAssets',
      'dateOfJoining',

    ];
    const exportFields3 = [
      'assetName',
      'statusChangeCount',
    ];
    const exportFields4 = [
      'assetName',
      'employeeName',
    ];
    // Extract headers for the selected fields
    const header1 = ['Aseet', 'Band', 'Employee Name'];
    const header2 = ['Aseet', 'Unassigned Assets', 'Date of Joining'];
    const header3 = ['Aseet', ' Number Off Time Repaired Asset'];
    const header4 = ['Aseet', ' Employee Name'];
    // Extract rows with only the selected fields
    const tab1 = this.allDataForDispay.map((record: any) =>
      exportFields1.map(field => `"${record[field] || ''}"`).join(',')
    );
    const tab2 = this.newAssetListingData.map((record: any) =>
      exportFields2.map(field => `"${record[field] || ''}"`).join(',')
    );
    const tab3 = this.repairedAsset.map((record: any) =>
      exportFields3.map(field => `"${record[field] || ''}"`).join(',')
    );
    const tab4 = this.returnAsset.map((record: any) =>
      exportFields4.map(field => `"${record[field] || ''}"`).join(',')
    );
    let rows = this.moduleName == 1 ? tab1 : this.moduleName == 2 ? tab2 : this.moduleName == 3 ? tab3 : tab4;
    let header = this.moduleName == 1 ? header1 : this.moduleName == 2 ? header2 : this.moduleName == 3 ? header3 : header4;
    // Create the CSV content
    const csvContent = [header, ...rows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const data = this.type == 'Recived Asset' ? 'Recived Asset' : 'Not Recived Asset';
    const moduleName = this.moduleName == 1 ? 'No Of Asset' : this.moduleName == 2 ? 'No of New Asset' : this.moduleName == 3 ? 'No of Time Repaired Asset' : data;
    // Trigger the download
    const a = document.createElement('a');
    a.href = url;
    const date = new Date();
    const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    a.download = `${moduleName}-${formattedDate}`
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  returnAssetFromEmp: any = []
  returnData() {
    this.returnAssetFromEmp = this.allDataForDispay.filter((elm: any) => elm.authorityDepartmentComment == 'RECEIVED_AFTER_EXIT');
    this.notRecivedAsset = this.allDataForDispay.filter((elm: any) => elm.authorityDepartmentComment == 'NOT_RECEIVED_AFTER_EXIT');
    this.returnAsset = this.type == 'Recived Asset' ? this.returnAssetFromEmp : this.notRecivedAsset;

  }
  onChangeSwitch(event: any) {
    this.isToggleOn = event?.checked;


    if (event?.checked == true) {
      this.type = 'Recived Asset';
      if ((this.moduleName == 4) && event?.checked == true) {
        this.type = 'Recived Asset';
      }
      this.returnData();
    } else if (event?.checked == false) {


      this.type = 'Not Recived Asset';
      if ((this.moduleName == 4) && event?.checked == false) {
        this.type = 'Not Recived Asset';
      }
      this.returnData();

    }
  }
}
